import React from 'react';
import {Link} from '../../raw-components/link/link';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {ILanguageSwitcherItem} from '../../../services/language/language-switcher/language-switcher-item.interface';
import {LanguageSwitcherSection} from '../../../services/language/language-switcher/language-switcher-section';
import {LanguageSwitcherListBox} from "./boxes/section-list/language-switcher-section-list.box";
import {LanguageSwitcherTitleBox} from "./boxes/section-title/language-switcher-section-title.box";
import {LanguageSwitcherListItemBox} from "./boxes/section-list/section-list-item/language-switcher-section-list-item.box";
import {LanguageSwitcherItemLabelBox} from "./boxes/section-list/section-list-item/section-list-item-label/language-switcher-item-label.box";
import {LanguageSwitcherItemCheckboxBox} from "./boxes/section-list/section-list-item/section-list-item-checkbox/language-switcher-item-checkbox.box";

export interface LanguageMenuComponentProps {
  section: LanguageSwitcherSection;
}

@observer
export class LanguageSwitcherSectionComponent extends OrbitComponent<LanguageMenuComponentProps> {

  private _selectItem = (item: ILanguageSwitcherItem) => {
      this.services.analytics.sendAnalytics("Navigation", "Lang_Switcher", item.title);
      item.makeCurrent();
  }

  private _renderOneItem(item: ILanguageSwitcherItem) {

    let htmlId = item.title.toLowerCase() + '-lang';
    return (
      <LanguageSwitcherListItemBox key={htmlId} onClick={() => this._selectItem(item)} className="cy-language-switcher-list">
        <input type={'radio'} id={htmlId} name={'lang'}/>
        <LanguageSwitcherItemLabelBox isSelected={item.isCurrent} className="cy-language-switcher-item">
          <LanguageSwitcherItemCheckboxBox isChecked={item.isCurrent} className="cy-language-item-checkbox"/>
          <Link href={item.url}>{item.title}</Link>
        </LanguageSwitcherItemLabelBox>
      </LanguageSwitcherListItemBox>
    );
  }

  render() {

    if(this.props.section.items.length === 0) {
      return null;
    }

    return (
      <>
        <LanguageSwitcherTitleBox>{this.props.section.title}</LanguageSwitcherTitleBox>
        <LanguageSwitcherListBox>
          {this.props.section.items.map(item => this._renderOneItem(item))}
        </LanguageSwitcherListBox>
      </>
    );
  }
}
